module.exports = {"450421100":"石桥镇","450421101":"沙头镇","450421102":"梨埠镇","450421105":"岭脚镇","450421108":"京南镇","450421109":"狮寨镇","450421110":"旺甫镇","450421112":"六堡镇","450421114":"木双镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450421.json
// module id = 1938
// module chunks = 0